import React from 'react';
import { useIntl } from 'react-intl';
import { IconSuccess } from '@americanexpress/dls-icons';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import styles from './RegistrationFallbackVerified.scss';

const RegistrationFallbackVerified = () => {
  const intl = useIntl();

  return (
    <div className={styles['registration-fallback-verified']}>
      <div className={styles['registration-fallback-verified__card']}>
        <Header />

        <div className={styles['registration-fallback-verified__body']}>
          <div className={styles['registration-fallback-verified__title-row']}>
            <IconSuccess
              className={styles['registration-fallback-verified__icon-symbol']}
              size="md"
              isFilled={true}
              color="brand"
              title={intl.formatMessage({ id: 'passkeyRegistration.fallbackVerified.title' })}
            />
            <h1 className={styles['registration-fallback-verified__title']}>
              {intl.formatMessage({ id: 'passkeyRegistration.fallbackVerified.title' })}
            </h1>
          </div>

          <p className={styles['registration-fallback-verified__message']}>
            {intl.formatMessage({ id: 'passkeyRegistration.fallbackVerified.message' })}
          </p>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default RegistrationFallbackVerified;
